import { Badge } from '@journ/ui/badge'

// Compact unread counter shown on a conversation row. Hidden at zero; caps the
// display at 99+ so the row layout never shifts.
const UnreadBadge = ({ count }: { count: number }) => {
	if (count <= 0) return null
	return (
		<Badge variant='default' className='h-5 min-w-5 justify-center rounded-sm px-1.5 text-xs'>
			{count > 99 ? '99+' : count}
		</Badge>
	)
}

export { UnreadBadge }
